import { useState } from "react";
import { useSearchParams } from "react-router";
import {
  DEFAULT_NEXT_PATH,
  safeNextPath,
  useBootstrap,
  wasSessionEnded,
} from "@entities/session";
import { usePasskeySignIn } from "../model/usePasskeySignIn";
import { useSignIn } from "../model/useSignIn";
import { ssoStartUrl } from "../lib/ssoStartUrl";
import { LoginCard, type LoginCardProps } from "./LoginCard";

export type SignInFormProps = Pick<LoginCardProps, "heading" | "autoFocus">;

export const SignInForm = ({ heading, autoFocus }: SignInFormProps = {}) => {
  const { data } = useBootstrap();
  const [params] = useSearchParams();
  const { submit, pending, failure } = useSignIn();
  const passkey = usePasskeySignIn(data?.auth.passkeys_enabled === true);
  // Читаем один раз при показе формы: флаг гаснет при следующем входе.
  const [sessionEnded] = useState(wasSessionEnded);
  if (!data) return null;
  const next = safeNextPath(params.get("next"), DEFAULT_NEXT_PATH);
  return (
    <LoginCard
      auth={data.auth}
      pending={pending}
      failure={passkey.failure ?? failure}
      sessionEnded={sessionEnded}
      {...(heading !== undefined ? { heading } : {})}
      {...(autoFocus !== undefined ? { autoFocus } : {})}
      ssoHref={(id) => ssoStartUrl(id, next)}
      onSubmit={(email, password) => {
        void submit(email, password);
      }}
      passkey={{
        available: passkey.available,
        pending: passkey.pending,
        onStart: () => {
          void passkey.start();
        },
      }}
    />
  );
};
